import React from 'react';
import { ReportLayout } from 'components/Layouts';

import EngagementReport from 'components/Reports/EngagementReport';

export default function EngagementDetail({ match, pathname }) {
  const { id } = match.params;

  return (
    <div>
      <ReportLayout wide>
        <EngagementReport reportId={id} pathname={location.pathname} />
      </ReportLayout>
    </div>
  );
}
